import { Component, OnInit } from '@angular/core';
import { AppDetails, UserDetails, RouterConstants, ProvidedRoles, DefaultValues } from '../../../Models/app-data';
import { FormsService } from 'src/app/Services/forms-service/forms.service';
import { HelperService } from 'src/app/Services/Common/helper.service';

@Component({
    selector: 'app-tool-bar',
    templateUrl: './tool-bar.component.html',
    styleUrls: ['./tool-bar.component.scss']
})
export class ToolBarComponent implements OnInit {

    loggedInUserDetails: UserDetails;
    appDetails = AppDetails;
    isIconOnly: boolean = false;
    routerConstants = RouterConstants;
    userRoles: ProvidedRoles = new ProvidedRoles();
    defaultValues: DefaultValues = new DefaultValues();

    constructor(private formsSrv: FormsService, private helperSrv: HelperService) { }

    async ngOnInit() {
    }

    toogleSideNav() {
        this.isIconOnly = !this.isIconOnly;
        this.helperSrv.setSideNavFlag(this.isIconOnly);
    }
}
